// extracted by mini-css-extract-plugin
export default {"TabsUi":"TabsUi_TabsUi__FbjaX","default":"TabsUi_default__IE7Km","malyaStyle":"TabsUi_malyaStyle__kxM6V","ant-space-item":"TabsUi_ant-space-item__Vksb-"};